import Link from 'next/link';
 import Icon from'@/components/ui/AppIcon';
 import AppImage from'@/components/ui/AppImage';

interface BlogCardProps {
  post: {
    id: string
    title: string
    excerpt: string
    author: string
    date: string
    category: string
    image: string
    alt: string
    readTime: string
  }
}

export default function BlogCard({ post }: BlogCardProps) {
  return (
    <Link
      href={`/blog/${post.id}`}
      className="group glass-card rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-border"
    >
      {/* Featured Image */}
      <div className="aspect-[16/10] overflow-hidden relative">
        <AppImage
          src={post.image}
          alt={post.alt}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-primary text-white px-3 py-1.5 rounded-full text-xs font-medium">
            {post.category}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-serif font-bold text-foreground mb-3 line-clamp-2 group-hover:text-primary transition-colors">
          {post.title}
        </h3>
        <p className="text-sm text-muted-foreground leading-relaxed mb-4 line-clamp-3">
          {post.excerpt}
        </p>

        {/* Meta */}
        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
              <Icon name="UserIcon" size={14} className="text-primary" />
            </div>
            <div>
              <div className="text-xs font-medium text-foreground">{post.author}</div>
              <div className="text-xs text-muted-foreground">{post.date}</div>
            </div>
          </div>
          <div className="flex items-center gap-1 text-xs text-muted-foreground">
            <Icon name="ClockIcon" size={14} />
            <span>{post.readTime}</span>
          </div>
        </div>
      </div>
    </Link>
  )
}